import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {FormattedNumber} from 'react-intl';

export class Price extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const {amount} = this.props;

    return (
      <span data-rw="price">
        {amount < 0 ? '-' : ''}
        <FormattedNumber
          value={Math.abs(amount)}
          style="currency"
          currency="GBP"
        />
      </span>
    );
  }
}

Price.propTypes = {
  amount: PropTypes.number.isRequired,
  currency: PropTypes.string
};

export default Price;



// WEBPACK FOOTER //
// ./components/Price/Price.js